module.exports = __webpack_public_path__ + "img/tf.tf90c38a9.svg";